import React from 'react';
import classnames from 'classnames';
import { map, capitalize } from 'lodash';
import { DOT } from 'constants/placeholders';
import UserMailToLink from 'components/UserMailToLink';
import { IUser } from 'interfaces/IUser';
import styles from './UpdateSummary.module.scss';
import { getDate, getData, getUpdateSummaryData } from './utils';

export interface UpdateSummarySource {
  createdAt: string | undefined;
  createdUser: IUser | undefined;
  updatedAt: string | undefined;
  updatedUser: IUser | undefined;
}

interface Props {
  data: UpdateSummarySource;
  wrapperClassName?: string;
}

const UpdateSummary: React.FC<Props> = ({ wrapperClassName, data }) => {
  const summary = getUpdateSummaryData(
    data?.createdAt,
    data?.createdUser,
    data?.updatedAt,
    data?.updatedUser,
  );

  if (!summary.created?.date && !summary.modified?.date) return null;

  return (
    <ul className={classnames(styles.list, wrapperClassName)}>
      {map(getData(summary), (value, key) =>
        value?.date ? (
          <li key={key}>
            <dl className={styles.details}>
              <dt>{capitalize(key)}</dt>
              <dd>{getDate(value?.date!)}</dd>
              <dd>
                {value?.user && <span> {DOT} </span>}
                <UserMailToLink user={value?.user!} />
              </dd>
            </dl>
          </li>
        ) : null,
      )}
    </ul>
  );
};

export { getUpdateSummaryData };
export default UpdateSummary;
